export default {
	setReference(state, data) {
		if (data) {
			state.references = data;
		}
	},

	setReferenceType(state, type) {
		state.referenceType = type;
	},

	clearReferenceType(state) {
		state.referenceType = null;
	}
};
